import { FieldController, TranslatableText } from '@dreryk/react-common';
import { PasswordInput } from '@dreryk/react-components';

type PasswordFieldProps = {
   readonly controller: FieldController<unknown>;
   readonly label: TranslatableText;
   readonly disabled?: boolean;
   readonly testId?: string;
};

const PasswordField = (props: PasswordFieldProps): JSX.Element => {
   return (
      <PasswordInput
         testId={props.testId ?? 'password'}
         label={props.label}
         controller={props.controller}
         disabled={props.disabled}
      />
   );
};

export { PasswordField };
